import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import { Modal } from 'react-bootstrap';
import { useInformationalModal } from '../context/InformationalModalContext';

const InformationalModalHeader: FC = () => {
  const { t } = useTranslate();
  const { actions, data } = useInformationalModal();

  const title = data.alias ? t(data.alias) || data.alias : t('InformationalOperation');

  return (
    <Modal.Header>
      <h5 className="modal-title">{title}&nbsp;</h5>
      <a className="close cursor-pointer" onClick={actions.handleCloseModal}>
        <em className="icon ni ni-cross" />
      </a>
    </Modal.Header>
  );
};

export default InformationalModalHeader;
